import { render, staticRenderFns } from "./Token.vue?vue&type=template&id=deec739a&scoped=true&"
import script from "./Token.vue?vue&type=script&lang=js&"
export * from "./Token.vue?vue&type=script&lang=js&"
import style0 from "./Token.vue?vue&type=style&index=0&id=deec739a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deec739a",
  null
  
)

export default component.exports